<template>
  <div class="yxtbiz-ai-robot__treasure">
    <transition :name="isFullscreen ? 'slideLeft' : 'slide'">
      <div v-if="customVisible" class="yxtbiz-ai-robot__treasure-small">
        <div class="yxtbiz-ai-robot__treasure-small--header">
          <div v-if="!isFullscreen" class="yxtbiz-ai-robot__treasure-small--back" @click="customVisible = false">
            <i class="yxt-icon-arrow-left font-size-24 font-bold"></i>
            <span class="ml2">{{$t('pc_comp_pageHeader_title'/** 返回 */)}}</span>
          </div>
          <yxt-svg v-else class="yxtbiz-ai-robot__treasure-small--close" @click.native="customVisible = false" :remote-url="`${$staticBaseUrl}ufd/55a3e0/assistent/pc/svg/`" width="20px" height="20px" icon-class="ai-closed"/>
          <yxt-svg :remote-url="`${$staticBaseUrl}ufd/55a3e0/assistent/pc/svg/`" width="16px" height="16px" icon-class="treasure_icon"/>
          <span class="standard-size-16 yxt-weight-5 ml4">{{$t('pc_biz_lbl_treasure_chest').d('百宝箱')}}</span>
        </div>
        <div class="yxtbiz-ai-robot__treasure-small--nav">
          <template v-if="showSearch">
            <div class="yxtbiz-ai-robot__treasure-small--search">
              <yxt-input v-model.trim="content" :placeholder="$t('pc_biz_msg_placeholder_txt').d('请输入内容文字')" searchNoIcon @search="postTreasureList">
                <i slot="suffix" class="yxt-input__icon yxt-icon-search hand" @click="postTreasureList"></i>
              </yxt-input>
            </div>
            <yxt-button class="ml12" type="text" @click="closeSearch">取消</yxt-button>
          </template>
          <template v-else>
            <yxt-tabs v-model="activeTab" @tab-click="handleTabsClick" height-size="small">
              <yxt-tab-pane :label="$t('pc_biz_lbl_winnow').d('精选')" name="tab1"></yxt-tab-pane>
              <yxt-tab-pane :label="$t('pc_biz_lbl_usual').d('我的常用')" name="tab2"></yxt-tab-pane>
            </yxt-tabs>
            <yxt-svg class="hand" :remote-url="`${$staticBaseUrl}ufd/407a24/assistent/pc/svg/`" width="20px" height="20px" icon-class="search" @click.native="toSearch"/>
          </template>
        </div>
        <div class="yxtbiz-ai-robot__treasure-small--body">
          <yxt-scrollbar
            class="yxtbiz-ai-robot-scrollbar"
            ref="scrollbar"
            :fit-height="true">
              <div v-if="loading" class="pos-center" v-loading="loading" yxt-loading-background="transparent"></div>
              <Treasure-list v-else :single="isFullscreen" :list="list" @toggleCollect="toggleCollect" @operation="handleOperation" />
          </yxt-scrollbar>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import TreasureList from './treasureList.vue';
import { getParentNode } from '../utils';
import { postTreasureList, postTreasureSubscribe } from '../service';

export default {
  name: 'TreasureDialog',
  components: {
    TreasureList
  },
  inject: ['getClient', 'getFullscreen'],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'small',
      validator: val => ['small', 'large'].includes(val)
    }
  },
  data() {
    return {
      content: '',
      activeTab: '',
      loading: false,
      list: [],
      showSearch: false
    };
  },
  computed: {
    customVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      }
    },
    isFullscreen() {
      return this.getFullscreen();
    }
  },
  watch: {
    customVisible(v) {
      if (v) {
        this.activeTab = 'tab1';
        this.$nextTick(()=>{
          const el = getParentNode(this.$el, 'yxtbiz-ai-robot--container');
          el && el.appendChild(this.$el);
          this.postTreasureList();
        });
      } else {
        Object.assign(this.$data, this.$options.data.call(this));
      }
    }
  },
  methods: {
    toSearch() {
      this.prevTab = this.activeTab;
      this.activeTab = 'tab1';
      this.showSearch = true;
      this.postTreasureList();
    },
    closeSearch() {
      this.activeTab = this.prevTab;
      this.showSearch = false;
      this.content = '';
      this.postTreasureList();
    },
    handleOperation(item) {
      this.$root.$emit('HANDLE_CLICK_TREASURE_ITEM', item);
      if (!this.isFullscreen) this.customVisible = false;
    },
    handleTabsClick() {
      this.postTreasureList();
      const scrollElement =
        this.$refs.scrollbar && this.$refs.scrollbar.$el.firstChild;
      scrollElement && (scrollElement.scrollTop = 0);
    },
    sleep(time) {
      return new Promise(resolve => {
        setTimeout(() => {
          resolve();
        }, time);
      });
    },
    async postTreasureList() {
      // 避开动画时间，缓解卡顿
      if (this.isFullscreen) await this.sleep(300);
      this.loading = true;
      postTreasureList({
        type: this.activeTab === 'tab1' ? 0 : 1,
        keyword: this.content,
        clientType: this.getClient()
      }).then(res=>{
        this.list = (res || []).map((item, index)=>{
          item.appBeanList = (item.appBeanList || []).map(sItem=>{
            // const { navAuthCode, operAuthCode } = sItem;
            // if (sItem.categoryId !== 0 && (navAuthCode && operAuthCode)) {
            //   return {
            //     ...sItem,
            //     permission: !commonUtil.checkActionPermission(navAuthCode, operAuthCode)
            //   };
            // }
            // return sItem;
            return {
              categoryCode: item.categoryCode,
              ...sItem
            };
          });

          return {
            ...item,
            index
          };
        });
      }).finally(()=>{
        this.loading = false;
      });
    },
    toggleCollect(item, sItem) {
      const { categoryId, id, identCode, subscribe } = sItem;
      const sub = subscribe === 0 ? 1 : 0;
      postTreasureSubscribe({
        categoryId,
        id,
        identCode,
        subscribe: sub
      }).then(()=>{
        sItem.subscribe = sub;
        if (sItem.subscribe === 1 && this.activeTab === 'tab2') {
          const findItem = this.list.find(l=>l.categoryName === item.categoryName && l.index === item.index);
          if (findItem) {
            findItem.appBeanList = findItem.appBeanList.filter(s=>s.id !== sItem.id);
            if (findItem.appBeanList.length === 0) {
              this.list = this.list.filter(l=>!(l.categoryName === item.categoryName && l.index === item.index));
            }
          }
        }

        this.$message.success(this.$t(sub === 0 ? 'pc_biz_msg_collect_success' : 'pc_biz_msg_cancel_collect_success'));
      });
    }
  }
};
</script>
